import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { TrackingStatus, ActivityFeed } from './components';

const Section = styled.div`
  padding: ${tokens.spacer.x2};
  border-top: 1px solid ${tokens.color.ui_border_light};
  display: flex;

  &:first-of-type {
    border-top: none;
  }

  > div > [aria-controls] {
    margin-bottom: 0;
  }
`;

const ScrollableSection = styled(Section)`
  overflow: auto;
`;

export const SpacesListSidebar = ({
  position = 'Workspace List',
}: {
  position?: string;
}): JSX.Element => (
  <>
    <Section>
      <TrackingStatus trackingUIPosition={`${position} Tracking Status`} />
    </Section>
    <ScrollableSection>
      <ActivityFeed trackingUIPosition={`${position} Activity Feed`} />
    </ScrollableSection>
  </>
);
